import {AssaysStatuses, IAssay, IOrder, Orders} from '../common/types';

export const createOrdersFromResponse = (responseOrders: []): Orders =>
  responseOrders.map((order: any): IOrder => ({
    id: order.idorder || -1,
    date: order.dt || '0000-00-00',
    address: order.address || '',
    assays: (order.packets || []).map((assay: any): IAssay => ({
      name: assay.name || '',
      status: getAssayStatus(assay),
    }))
  }));


const getAssayStatus = (assay: any): AssaysStatuses => {
  if (assay.test_ready === '0') return AssaysStatuses.NotReady;
  if (Number(assay.test_ready) >= Number(assay.test_total)) return AssaysStatuses.Done;
  return AssaysStatuses.InProgress;
};

